import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FaceIcon(props: IconProps) {
    return <Icon {...props} iconKey={"face"}/>
}
